// Product page: mirror WordPress's gallery (one large image + thumbnail strip)
// and place the Sold tab at the top-left of the media column.
(function () {
  function init() {
    var media = document.querySelector('.product-information__media');
    if (!media) return;

    // 1. Sold tab belongs over the media column (WP renders it above the image)
    var badge = document.querySelector('.awad-product-badge--sold');
    if (badge && !media.contains(badge)) media.prepend(badge);

    // 2. Thumbnail strip built from the gallery's slides
    if (media.querySelector('.awad-thumbs')) return;
    var slides = Array.prototype.slice.call(
      media.querySelectorAll('slideshow-slide, .product-media-container')
    );
    if (slides.length < 2) return;

    var strip = document.createElement('div');
    strip.className = 'awad-thumbs';
    slides.slice(0, 4).forEach(function (slide, i) {
      var img = slide.querySelector('img');
      if (!img) return;
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'awad-thumbs__item';
      var t = document.createElement('img');
      t.src = img.currentSrc || img.src;
      t.alt = img.alt || '';
      t.loading = 'lazy';
      b.appendChild(t);
      b.addEventListener('click', function () {
        slide.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        strip.querySelectorAll('.awad-thumbs__item').forEach(function (el) {
          el.classList.remove('is-active');
        });
        b.classList.add('is-active');
      });
      if (i === 0) b.classList.add('is-active');
      strip.appendChild(b);
    });
    // Inside the media column, which CSS makes a flex column so it sizes to
    // gallery + strip on every browser (a plain block container kept its
    // gallery-derived height and the strip overflowed under the title).
    if (strip.children.length) media.appendChild(strip);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
